<template>
  <div class="app-body" id="view">
    <div class="insights">
      <div id="insights-filters" class="pt-1 pb-1" style="position: relative; overflow: hidden;">
        <div class="row mt-2">
          <div class="col-12 text-center">
            <!-- `selectedInsight` watcher calls `loadInsight` method -->
            <el-radio-group class="col-12 no-select pull-left mt-1"
                            size="small"
                            v-model="selectedInsight"
                            >
              <el-radio-button :key="insight.id"
                               :label="insight"
                               v-for="(insight) in insights">
                {{insight.name}}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div id="insights-show" v-if="loadedInsightUrl">
        <insights-show :url="loadedInsightUrl"
                       :query="showFilters? query : null"
                       :split-date-filter="isCallVolume">
          <template class="d-block"
                    #filters
                    v-if="showFilters">
            <div class="filter-container">
              <div class="p-0 mb-3">
                <label class="p-0 m-0 _500 w-100">Date Filter:</label>
                <date-selector class="date-filter"
                               :default_date_range="initialDateRange"
                               :allow_initial_reset="false"/>
              </div>

              <div class="p-0 mb-3"
                   v-if="isContactReport">
                <label class="p-0 m-0 _500 w-100">Baseline:</label>
                <el-select class="no-select"
                           v-model="query.baseline">
                  <el-option :key="item"
                             :value="item"
                             v-for="item in baselines">
                  </el-option>
                </el-select>
              </div>

              <div class="p-0 mb-3"
                   v-if="isContactReport" >
                <label class="p-0 m-0 _500 w-100">Metric:</label>
                <el-select class="no-select"
                           v-model="query.metrics">
                  <el-option :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             v-for="item in metrics">
                  </el-option>
                </el-select>
              </div>

              <div class="p-0 mb-3"
                   v-if="isCallVolume" >
                <label class="p-0 m-0 _500 w-100">Direction:</label>
                <el-select class="no-select"
                           clearable
                           v-model="query.direction">
                  <el-option :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             v-for="item in directions">
                  </el-option>
                </el-select>
              </div>

              <div class="p-0 mb-3"
                   v-if="showLineFilter">
                <label class="p-0 m-0 _500 w-100">Filter by Line:</label>
                <campaign-selector :multiple="!isContactReport"
                                   :clearable="true"
                                   :value="query.filter_by_line"
                                   @input="changeCampaigns"
                                   @change="changeCampaigns">
                  <el-option-group key="No Lines"
                                   label="No Lines"
                                   v-if="isContactReport">
                    <el-option :key="item"
                               :value="item"
                               v-for="item in moreLineOptions">
                    </el-option>
                  </el-option-group>
                </campaign-selector>
              </div>

              <div class="p-0 mb-3"
                   v-if="showInboxFilter">
                  <label class="p-0 m-0 _500 w-100">Filter by Inbox:</label>
                  <ring-group-selector multiple
                                       custom-placeholder="Select Inboxes"
                                       v-model="query.filter_by_inbox"
                                       @change="changeTeamInbox" />

              </div>

              <div class="p-0 mb-3"
                   v-if="isHourlyHeatmap">
                  <label class="p-0 m-0 _500 w-100">Filter by Inbox:</label>
                  <ring-group-selector multiple
                                       collapsable
                                       custom-placeholder="Select Inbox"
                                       v-model="query.filter_by_ring_group"
                                       @change="changeRingGroup" />
              </div>

              <div class="p-0 mb-3"
                   v-if="showUserFilter">
                <label class="p-0 m-0 _500 w-100">Filter by User:</label>
                <user-selector placeholder="Select User"
                               :multiple="!isContactReport"
                               :hide_extensions="true"
                               :value="query.filter_by_user"
                               :collapseTags="true"
                               @change="changeUser">
                  <el-option-group key="No Users"
                                   label="No Users"
                                   v-if="isContactReport">
                    <el-option :key="item"
                               :value="item"
                               v-for="item in moreUserOptions">
                    </el-option>
                  </el-option-group>
                </user-selector>
              </div>

              <div class="p-0 mb-3"
                   v-if="showTeamFilter">
                <label class="p-0 m-0 _500 w-100">Filter by Team:</label>
                <team-selector :multiple="!isContactReport"
                               :collapsable="true"
                               :clearable="true"
                               :value="query.filter_by_team"
                               @change="changeTeam"/>
              </div>

              <div class="p-0 mb-3"
                   v-if="isAloAiReport">
                <label class="p-0 m-0 _500 w-100">Filter by Type:</label>
                <el-select class="no-select"
                           v-model="query.filter_by_type"
                           clearable
                           :disabled="!!query.filter_by_agent"
                           @change="changeAloAiType">
                  <el-option :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             v-for="item in aloaiCommunicationTypes">
                  </el-option>
                </el-select>
              </div>

              <div class="p-0 mb-3"
                   v-if="isAloAiReport">
                <label class="p-0 m-0 _500 w-100">Filter by Direction:</label>
                <el-select class="no-select"
                           v-model="query.filter_by_direction"
                           clearable
                           :disabled="!!query.filter_by_agent"
                           @change="changeAloAiDirection">
                  <el-option :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             v-for="item in aloaiDirections">
                  </el-option>
                </el-select>
              </div>

              <div class="p-0 mb-3"
                   v-if="isAloAiReport">
                <label class="p-0 m-0 _500 w-100">Filter by Agent:</label>
                <alo-ai-user-selector 
                  :multiple="false"
                  :clearable="true"
                  :value="query.filter_by_agent"
                  placeholder="Select Agent"
                  @change="changeAloAiUser"/>
              </div>

              <div class="p-0 mb-3"
                   v-if="isAloAiReport">
                <label class="p-0 m-0 _500 w-100">Filter by Communication Line:</label>
                <campaign-selector 
                  :multiple="false"
                  :clearable="true"
                  :value="query.filter_by_campaign"
                  placeholder="Select Communication Line"
                  @input="changeAloAiCampaign"
                  @change="changeAloAiCampaign"/>
              </div>

              <div class="p-0 mb-3"
                   v-if="isAloAiReport">
                <label class="p-0 m-0 _500 w-100">Filter by Communication Handling:</label>
                <el-select class="no-select"
                           v-model="query.filter_by_resolution"
                           clearable
                           @change="changeAloAiResolution">
                  <el-option :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             v-for="item in aloaiResolutions">
                  </el-option>
                </el-select>
              </div>
              
              <div class="p-0 mb-3"
                   v-if="isSpeedToLeadReport">
                <label class="p-0 m-0 _500 w-100">Filter by Metric:</label>
                <el-select class="d-inline-block w-full" 
                           autocomplete="off"
                           collapse-tags
                           clearable
                           filterable
                           default-first-option
                           placeholder="Select Metric"
                           data-testid="metric-selector"
                           v-model="query.filter_by_metric"
                           @clear="changeSpeedToLeadMetric"
                           @change="changeSpeedToLeadMetric">
                    <el-option :key="option.value"
                               :label="option.label"
                               :value="option.value"
                              v-for="option in speedToLeadMetrics">
                        <span>{{ option.label }}</span>
                    </el-option>
                </el-select>
              </div>

              <div class="p-0 mb-3"
                   v-if="isSpeedToLeadReport">
                <label class="p-0 m-0 _500 w-100">Filter by Channel:</label>
                <el-select class="d-inline-block w-full" 
                           autocomplete="off"
                           collapse-tags
                           clearable
                           filterable
                           multiple
                           default-first-option
                           placeholder="Select Metric"
                           data-testid="metric-selector"
                           v-model="query.filter_by_channel"
                           @clear="changeChannel"
                           @change="changeChannel">
                    <el-option :key="option.value"
                               :label="option.label"
                               :value="option.value"
                              v-for="option in channels">
                        <span>{{ option.label }}</span>
                    </el-option>
                </el-select>
              </div>
            </div>
          </template>
        </insights-show>
      </div>
    </div>
  </div>
</template>
<style scoped>
.el-select {
  display: inline;
}

.date-filter{
  min-width: 100%;
}

.filter-container{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px 20px;
  padding-bottom: 10px;
  justify-content: center;
  align-items: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.filter-container > div:first-child {
  grid-column: 1 / 2;
}

.filter-container > div:nth-child(2) {
  grid-column: 1 / 2;
}

@media (max-width: 769px) {
  .filter-container {
    grid-template-columns: 1fr;
  }
}
</style>
<script>
import { debounce } from "lodash"
import { mapGetters, mapState } from 'vuex'
import auth from '../../auth'
import AloAiUserSelector from "../../components/alo-ai-user-selector.vue"
import DateSelector from "../../components/date-selector"
import RingGroupSelector from '../../components/ring-group-selector'
import TeamSelector from "../../components/team-selector"
import * as CommunicationDirection from '../../constants/communication-direction'
import * as CommunicationTypes from '../../constants/communication-types'
import * as User from '../../constants/user'
import { acl_mixin, date_mixin, scroll_mixin, styling_mixin } from '../../mixins'
import InsightsShow from "./insights-show.vue"

export default {
  name: 'insights-index',

  mixins: [
    styling_mixin,
    date_mixin,
    acl_mixin,
    scroll_mixin
  ],

  components: {
    DateSelector,
    InsightsShow,
    TeamSelector,
    RingGroupSelector,
    CommunicationTypes,
    UserSelector: () => import('../../components/user-selector.vue'),
    AloAiUserSelector,
    CampaignSelector: () => import('../../components/campaign-selector.vue')
  },

  props: {
    slug: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      auth: auth,
      env: null,
      loading: false,
      selectedInsight: null,
      loadedInsightUrl: null,
      insights: [],
      User,
      query: {
        baseline: 'Lines',
        date_filter: '',
        filter_by_line: '',
        filter_by_user: '',
        filter_by_team: '',
        filter_by_inbox: '',
        filter_by_ring_group: '',
        metrics: '',
        filter_by_metric: '',
        filter_by_channel: '',
        direction: '',
        filter_by_agent: '',
        filter_by_type: '',
        filter_by_direction: '',
        filter_by_campaign: '',
        filter_by_resolution: ''
      },
      baselines: ['Lines', 'Users'],
      metrics: [
        {
          label: 'Overview',
          value: ''
        },
        {
          label: 'New Contacts',
          value: 'New Contacts'
        },
        {
          label: 'DNC Contacts',
          value: 'DNC Contacts'
        }
      ],
      directions: [
        {
          label: 'Inbound',
          value: '1'
        },
        {
          label: 'Outbound',
          value: '2'
        }
      ],
      speedToLeadMetrics: [
        {
          label: '24hs +',
          value: '24h+'
        },
        {
          label: '1h ~ 24h',
          value: '15_60m'
        },
        {
          label: '5min ~ 15min',
          value: '5_15m'
        },
        {
          label: '1min ~ 5min',
          value: '1_5m'
        },
        {
          label: '0 ~ 1min',
          value: '0_1m'
        },
        {
          label: 'Not contacted',
          value: 'uncontacted'
        },
      ],
      channels: [
        {
          label: 'Call',
          value: CommunicationTypes.CALL
        },
        {
          label: 'SMS',
          value: CommunicationTypes.SMS
        },
        {
          label: 'RVM',
          value: CommunicationTypes.RVM
        },
        {
          label: 'E-mail',
          value: CommunicationTypes.EMAIL
        },
      ],
      aloaiCommunicationTypes: [
        {
          label: 'All',
          value: ''
        },
        {
          label: 'Call',
          value: CommunicationTypes.CALL
        },
        {
          label: 'SMS',
          value: CommunicationTypes.SMS
        },
      ],
      aloaiDirections: [
        {
          label: 'All',
          value: ''
        },
        {
          label: 'Inbound',
          value: CommunicationDirection.INBOUND
        },
        {
          label: 'Outbound',
          value: CommunicationDirection.OUTBOUND
        },
      ],
      aloaiResolutions: [
        {
          label: 'All',
          value: ''
        },
        {
          label: 'Normal Call',
          value: '14'
        },
        {
          label: 'Missed Line Call',
          value: '15'
        },
        {
          label: 'Missed Inbox Call',
          value: '16'
        }
      ],
      moreUserOptions: ['Contacts with no user'],
      moreLineOptions: ['Contacts with no line'],
      reportsWithFilters: ['contacts', 'hourly-heatmap', 'team-inboxes', 'speed-to-lead', 'call-volume', 'aloai', 'power-dialer'],
      initialDateRange: ''
    }
  },

  computed: {
    ...mapState('cache', ['current_company']),
    ...mapGetters('cache', ['isTrial']),
    ...mapGetters({
      filter: 'getFilter',
    }),

    showFilters () {
      return this.reportsWithFilters.includes(this.selectedInsight?.slug)
    },

    isContactReport () {
      return this.selectedInsight?.slug === 'contacts'
    },

    isTeamInboxesReport () {
      return this.selectedInsight?.slug === 'team-inboxes'
    },

    isHourlyHeatmap () {
      return this.selectedInsight?.slug === 'hourly-heatmap'
    },

    isSpeedToLeadReport () {
      return this.selectedInsight?.slug === 'speed-to-lead'
    },

    isCallVolume () {
      return this.selectedInsight?.slug === 'call-volume'
    },

    isAloAiReport () {
      return this.selectedInsight?.slug === 'aloai'
    },

    isPowerDialerReport () {
      return this.selectedInsight?.slug === 'power-dialer'
    },

    showLineFilter () {
      return !this.isTeamInboxesReport && !this.isAloAiReport && !this.isPowerDialerReport
    },

    showUserFilter () {
      return !this.isAloAiReport
    },

    showTeamFilter () {
      return !this.isContactReport && !this.isAloAiReport
    },

    showInboxFilter () {
      return this.isTeamInboxesReport && !this.isAloAiReport
    },

    getAloAiTypeValue () {
      if (!this.query.filter_by_type) return null
      return this.query.filter_by_type
    },

    getAloAiDirectionValue () {
      if (!this.query.filter_by_direction) return null
      return this.query.filter_by_direction
    },
  },

  /**
   * Fetches the build information and sets the environment variable.
   * Called before the component is created.
   */
  beforeCreate() {
    axios.get('/build-info.json')
        .then(res => {
          this.env = res.data.env
        })
        .catch(err => {
          console.log(err)
        })
  },

  /**
   * Sets the title and fetches insights when the component is mounted.
   */
  mounted() {
    this.setTitle()
    this.fetchInsights()
    this.applySavedFilters()
  },

  /**
   * Checks user authentication and permissions before entering the route.
   * Redirects to appropriate pages based on user role and permissions.
   */
  beforeRouteEnter(to, from, next) {
    auth.check()
        .then((res) => {
          next(vm => {
            if (!vm.hasPermissionTo('list insights')) {
              next(vm.goBack())
            }
          })

          if (res.data.user.is_reseller) {
            // redirect to account management portal if the company is a reseller
            next({name: 'Account Management Portal'})
          } else {
            next()
          }
        })
        .catch((err) => {
          next({name: 'Login', query: {redirect: to.fullPath}})
        })
  },

  watch: {
    selectedInsight: function () {
      this.getInsightUrl()

      if(this.showFilters){
        this.applySavedFilters()
      }
    },

    'filter.from_date': function (data) {
      if (data) {
        this.query.date_filter = `${data.split(' ')[0]}~${this.filter.to_date?.split(' ')[0]}`
      } else {
        this.query.date_filter = ''
      }

      if(this.showFilters && !this.isContactReport){
        this.saveFilters()
      }
    },

    'filter.to_date': function (data) {
      if (data) {
        this.query.date_filter = `${this.filter.from_date?.split(' ')[0]}~${data.split(' ')[0]}`
      } else {
        this.query.date_filter = ''
      }

      if(this.showFilters && !this.isContactReport){
        this.saveFilters()
      }
    },

    'query.direction': function () {
      if(this.showFilters && !this.isContactReport){
        this.saveFilters()
      }
    }
  },

  methods: {
    /**
     * Initializes the selected insight based on the provided slug or the number of insights available.
     *
     * If a slug is provided in the url, it searches for an insight with a matching slug and sets it as the selected insight.
     * If no slug is provided and there is exactly one insight available, it sets that insight as the selected insight.
     */
    initializeSelectedInsight() {
      if (this.slug) {
        this.selectedInsight = this.insights.find(insight => insight.slug === this.slug)
      } else if (this.insights.length > 0) {
        this.selectedInsight = this.insights[0]
      }
    },

    /**
     * Loads the selected insight by making an API call.
     * Sets the `loadedInsight` and updates the URL with the selected insight's slug.
     */
    getInsightUrl() {
      this.loading = true
      this.loadedInsightUrl = null

      axios.get('/api/v2/insights/' + this.selectedInsight.id + '/url')
          .then(response => {
            this.loadedInsightUrl = response.data.url
              this.setupTokenRefresh();
          })
          .catch(error => {
            console.error('Error fetching insight url:', error)
          })
      this.loading = false

      // check if the current route is `/insights` and the selected insight has a slug
      this.$router.push({
        name: 'View Insight',
        params: {
          slug: this.selectedInsight.slug
        }
      })
    },
      // Set up a timer to refresh the token
      setupTokenRefresh() {
          const refreshIntervalMinutes = 14; // 1 minute less than the token's validity (which is 15 minutes)
          const refreshIntervalMs = refreshIntervalMinutes * 60 * 1000; // Convert minutes to milliseconds

          setInterval(this.refreshUrl, refreshIntervalMs);
      },
      refreshUrl() {
          axios.get(`/api/v2/insights/${this.selectedInsight.id}/url`)
              .then(response => {
                  this.loadedInsightUrl = response.data.url; // Update child via prop
              })
              .catch(error => {
                  console.error('Error refreshing URL:', error);
              });
      },
    /**
     * Fetches the list of insights by making an API call.
     * Initializes the selected insight after fetching the insights.
     */
    fetchInsights() {
      this.loading = true
      axios.get('/api/v2/insights')
          .then(response => {
            this.insights = response.data
            this.initializeSelectedInsight()
          })
          .catch(error => {
            console.error('Error fetching insights:', error)
          })

      this.loading = false
    },

    /**
     * Sets the page title by making an API call to fetch static data.
     * If an error occurs, sets a default title and handles the error.
     */
    setTitle() {
      axios.get('/get-statics')
          .then(res => {
            let name = res.data.name
            this.setPageTitle('Insights - ' + name)
          })
          .catch(err => {
            this.setPageTitle('Insights - Aloware')
            console.log(err)
            this.$root.handleErrors(err.response)
          })
    },

    changeUser (values) {
      this.query.filter_by_user = values
      this.query.filter_by_line = !values || !this.isContactReport? this.query.filter_by_line : ''

      if(this.showFilters  && !this.isContactReport){
        this.saveFilters()
      }
    },

    changeCampaigns (values) {
      this.query.filter_by_line = values
      this.query.filter_by_user = !values || !this.isContactReport? this.query.filter_by_user : ''

      if(this.showFilters && !this.isContactReport){
        this.saveFilters()
      }
    },

    changeTeam (values) {
      this.query.filter_by_team = values ? values : ''

      if(this.showFilters && !this.isContactReport){
        this.saveFilters()
      }
    },
    
    changeTeamInbox (values) {
      this.query.filter_by_inbox = values ? values : ''

      if(this.showFilters && !this.isContactReport){
        this.saveFilters()
      }
    },

    changeRingGroup (values) {
      this.query.filter_by_ring_group = values ? values : ''

      if(this.showFilters && !this.isContactReport){
        this.saveFilters()
      }
    },

    changeSpeedToLeadMetric (values) {
      this.query.filter_by_metric = values ? values : ''

      if(this.showFilters && !this.isContactReport){
        this.saveFilters()
      }
    },

    changeChannel (values) {
      this.query.filter_by_channel = values ? values : ''

      if(this.showFilters && !this.isContactReport){
        this.saveFilters()
      }
    },

    changeAloAiUser (values) {
      this.query.filter_by_agent = values ? values : ''
      
      // Clear type and direction when user is selected
      if (values) {
        this.query.filter_by_type = ''
        this.query.filter_by_direction = ''
      }

      this.saveFilters()
    },

    changeAloAiType (values) {
      this.query.filter_by_type = values ? values : ''
      // Clear agent selection when type changes
      this.query.filter_by_agent = ''

      this.saveFilters()
    },

    changeAloAiDirection (values) {
      this.query.filter_by_direction = values ? values : ''
      // Clear agent selection when direction changes
      this.query.filter_by_agent = ''

      this.saveFilters()
    },

    changeAloAiCampaign (values) {
      this.query.filter_by_campaign = values ? values : ''

      this.saveFilters()
    },

    changeAloAiResolution (values) {
      this.query.filter_by_resolution = values ? values : ''

      this.saveFilters()
    },

    applySavedFilters () {
      const savedQuery = localStorage.getItem(this.selectedInsight?.slug)

      if (savedQuery) {
        const savedQueryObj = JSON.parse(savedQuery)
        Object.keys(savedQueryObj).forEach(key => {
            this.query[key] = savedQueryObj[key]
        })
        this.initialDateRange = this.query.date_filter.replace(/-/g, '/').replace('~', '-')
        if(!this.initialDateRange){
          this.initialDateRange = 'All Time'
        }
      } else {
        // set date filter default based on report type
        const days = this.isPowerDialerReport ? 7 : 30
        const today = moment().tz(this.current_company.timezone)
        this.initialDateRange = `${today.clone().subtract(days, 'days').startOf('day').format('MM/DD/YYYY')} - ${today.clone().endOf('day').format('MM/DD/YYYY')}`
      }
    },

    saveFilters: debounce(function () {
      if(!this.query.date_filter && this.filter?.from_date) {
        this.query.date_filter = `${this.filter?.from_date?.split(' ')[0]}~${this.filter?.to_date?.split(' ')[0]}`
      }
      localStorage.setItem(this.selectedInsight.slug, JSON.stringify(this.query))
    }, 500)
  },

}
</script>
